"use strict";function stopRealtimeTracing$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.stopRealtimeTracing$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.realm.stopRealtimeTracing";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.13"},_a)),exports.stopRealtimeTracing$=stopRealtimeTracing$,exports.default=stopRealtimeTracing$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/realm/stopRealtimeTracing.js
// module id = 986
// module chunks = 106